module.exports = __webpack_public_path__ + "static/media/fpdf.56d7992f.svg";